<template>
  <power-bi code="eyJrIjoiYjYxMTAwNjQtNGM3Zi00ZGM5LTkwMmEtZDRiZTg3N2YwNDhjIiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
